
import { Suspense } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import PartnersSection from './components/PartnersSection';
import CTASection from './components/CTASection';
import { useSEO, SITE_URL } from '../../hooks/useSEO';

const ReferralPartnersPage = () => {
  useSEO({
    title: 'Referral Partner Program — Earn by Referring Mortgage Firms | Mortgage Moat',
    description: 'Join the Mortgage Moat referral partner program. Earn commissions by referring mortgage companies to our cybersecurity services. Simple, rewarding, and built for industry professionals.',
    keywords: 'cybersecurity referral program, mortgage security partner, referral commissions, partner program',
    canonical: '/referral-partners',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Referral Partners — Mortgage Moat',
        url: `${SITE_URL}/referral-partners`,
        description: 'Join the Mortgage Moat referral partner program and earn commissions by referring mortgage companies to our cybersecurity services.',
        publisher: { '@type': 'Organization', name: 'Mortgage Moat', url: SITE_URL },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
          { '@type': 'ListItem', position: 2, name: 'Referral Partners', item: `${SITE_URL}/referral-partners` },
        ],
      },
    ],
  });

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen flex flex-col bg-white">
        <Header />
        <main className="flex-grow">
          <HeroSection />
          <IntroSection />
          <PartnersSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </Suspense>
  );
};

export default ReferralPartnersPage;
